module.exports = __webpack_public_path__ + "img/ugselectedtick.ca32668f.svg";